import { isColumnVisibleByDefault } from '../../../utils/partialPermissionUtils';
import { from_links_to_string_sucessor } from '../../../assets/js/custom_gantt_fields/custom_sucessor';

const customSucessorsCol = (gantt, t) => {
  const name = 'custom_sucessors';
  const isVisible = isColumnVisibleByDefault(name);

  return {
    name,
    label: t('gantt.columns.customSucessors', 'Sucesoras'),
    width: '80',
    align: 'center',
    editor: { type: 'text', map_to: 'custom_sucessors' },
    resize: true,
    template: function (activity) {
      const isOdd = gantt.oddColsConfig?.custom_sucessors || false;
      const hasChild = gantt.hasChild(activity.id);
      let sucessorsString = '';
      try {
        sucessorsString = from_links_to_string_sucessor(gantt)(activity);
      } catch (e) {
        console.error('Error formatting successors:', e);
      }
      return sucessorsString; 
    },
    hide: !isVisible,
    data_type: 'string',
  };
};

export default customSucessorsCol; 